import React, {useState} from 'react';
import Button from '@/components/ui/Button';
import BaseModal from './BaseModal';
import {ConfirmationModalProps} from './types';
import i18n from 'i18n';

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onClose,
    title,
    message,
    confirmText = i18n.t('jt_confirm.text') || 'Confirm',
    cancelText = i18n.t('jt_cancel.text') || 'Cancel',
    variant = 'info',
    onConfirm,
    loading = false,
    size = 'lg',
    centered = true,
    backdrop = 'static',
    className = '',
    hideCloseButton = false,
}) => {
    const [isConfirming, setIsConfirming] = useState(false);

    const handleConfirm = async () => {
        setIsConfirming(true);
        try {
            await onConfirm();
            onClose();
        } catch (error) {
            console.error('Confirmation action failed:', error);
        } finally {
            setIsConfirming(false);
        }
    };

    const getConfirmButtonVariant = () => {
        switch (variant) {
            case 'danger':
                return 'danger';
            case 'warning':
                return 'warning';
            default:
                return 'info';
        }
    };

    const footer = (
        <>
            <Button 
                variant="secondary" 
                onClick={onClose}
                disabled={isConfirming || loading}
                data-cy="confirmation-btn-1">
                {cancelText}
            </Button>
            <Button 
                variant={getConfirmButtonVariant()}
                onClick={handleConfirm}
                disabled={isConfirming || loading}
                data-cy="confirmation-btn">
                {isConfirming || loading ? 'Processing...' : confirmText}
            </Button>
        </>
    );

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size={size}
            centered={centered}
            backdrop={backdrop}
            className={className}
            footer={footer}
            hideCloseButton={hideCloseButton}
        >
            <p>{message}</p>
        </BaseModal>
    );
};

export default ConfirmationModal;
